import React from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { ApartmentListUnderZoneHead } from '../commonfile/ApartmentListUnderZoneHead'
import useAuthStore from '../../store/useAuthStore'

const ZoneHeadApartmentList = () => {
    const { user } = useAuthStore()
    return (
        <>
            <NormalContainerWithHeader headerText={"Apartment List"}>
                <ApartmentListUnderZoneHead id={user?.id} />
            </NormalContainerWithHeader>
        </>
    )
}

export default ZoneHeadApartmentList